module.exports = __webpack_public_path__ + "static/media/eye.e8c36990.svg";